// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2EsVR","title":"Images90_title__1qdwZ","images":"Images90_images__G2ZFr"};